// extracted by mini-css-extract-plugin
export default {"footer-socials-title":"footer-socials_footer-socials-title__WlDae","footer-socials-container":"footer-socials_footer-socials-container__LsLPz"};